define( function() {
	return ( /\S+/g );
} );



/*****************
 ** WEBPACK FOOTER
 ** F:/actions-runner/_work/scpbuildinig_sentience.portal.devops/scpbuildinig_sentience.portal.devops/src/Production/Portal/Cloud.Platform.Global.Portal.DevOps.Web/~/jquery/src/var/rnotwhite.js
 ** module id = 836
 ** module chunks = 2
 **/